import React, { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import { Outlet } from "react-router-dom";

function LoadingFallback() {
  return (
    <div className="d-flex justify-content-center mt-5 pt-5 w-100">
      <Spinner animation="border" role="status" />
    </div>
  );
}

function SuspenseWrapper() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  );
}

export default SuspenseWrapper;
